// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3bf8P","header":"PatientBlock_header__1WRI1","label":"PatientBlock_label__9bans","option":"PatientBlock_option__1FR9P"};